const DISTINCT_COLORS: [number, number, number][] = [
    [255, 45,  45],   // vivid red
    [30,  210, 60],   // vivid green
    [255, 160, 0],    // vivid orange
    [30,  100, 255],  // vivid blue
    [180, 30,  255],  // vivid purple
    [0,   220, 220],  // vivid teal
    [255, 40,  190],  // vivid pink
    [200, 190, 0],    // vivid yellow-olive
    [0,   190, 255],  // vivid sky blue
    [255, 100, 30],   // vivid coral
];

const typeIndexMap: Record<string, number> = {};
let typeCounter = 0;

export const getMarkerColor = (markerType: string): [number, number, number] => {
    if(markerType=="poimarker") return [80,120,200]
    if (!(markerType in typeIndexMap)) {
        typeIndexMap[markerType] = typeCounter++ % DISTINCT_COLORS.length;
    }
    return DISTINCT_COLORS[typeIndexMap[markerType]];
};

// Flatten data that may be a flat array of points or a nested company/branches structure
export const flattenMarkerData = (data: any[]): any[] => {
    if (!data?.length) return [];
    if (data[0]?.branches) {
        return data.flatMap((item: any) => item.branches ?? []);
    }
    return data;
};
